// Transparent vertical bar on the LEFT of the table holding the extra buttons:
// mic, speaker (voice chat), sound (game sound effects) and the previous-rounds points table.
import React from 'react';
import { MicIcon, SpeakerIcon, MusicIcon, PointsIcon } from './VoiceIcons';

const GameSideBar = ({
  voiceEnabled = false,
  micOn = false,
  speakerOn = true,
  permissionDenied = false,
  onToggleMic,
  onToggleSpeaker,
  onOpenMicSettings,
  soundOn = true,
  onToggleSound,
  onShowPoints,
  onShowRounds,
  onShowDecks,
  gameStarted = false,
  isMobile = false,
  canAutoDrop = false,
  isAutoDropQueued = false,
  onToggleAutoDrop
}) => {
  const size = isMobile ? 17 : 20;
  return (
    <div className={`game-side-bar ${isMobile ? 'mobile' : ''}`} data-tour="chat">
      {/* Group 1: mic, speaker, music */}
      {voiceEnabled && (
        <>
          <button
            className={`gsb-btn ${micOn ? 'active' : 'off'}`}
            onClick={onToggleMic}
            title={micOn ? 'Mic on — tap to mute' : 'Mic muted — tap to unmute'}
          >
            <MicIcon off={!micOn} size={size} />
          </button>
          {permissionDenied && (
            <button className="gsb-btn warn" onClick={onOpenMicSettings} title="Microphone blocked — tap to open settings">!</button>
          )}
          <button
            className={`gsb-btn ${speakerOn ? 'active' : 'off'}`}
            onClick={onToggleSpeaker}
            title={speakerOn ? 'Speaker on — tap to mute' : 'Speaker muted — tap to unmute'}
          >
            <SpeakerIcon off={!speakerOn} size={size} />
          </button>
        </>
      )}
      <button
        className={`gsb-btn ${soundOn ? 'active' : 'off'}`}
        onClick={onToggleSound}
        title={soundOn ? 'Game sounds on — tap to mute' : 'Game sounds off — tap to unmute'}
      >
        <MusicIcon off={!soundOn} size={size} />
      </button>
      {/* Group 2: points + rounds details */}
      {gameStarted && (
        <>
          <div className="gsb-sep" />
          <button className="gsb-btn points" onClick={onShowPoints} title="Previous rounds — points table">
            <PointsIcon size={size} />
          </button>
          <button className="gsb-btn points" onClick={onShowRounds} title="Round-by-round points">
            <span style={{ fontSize: size - 2, lineHeight: 1 }}>📋</span>
          </button>
        </>
      )}
      {/* Group 3: everything else (card style, auto drop) */}
      {(onShowDecks || (gameStarted && canAutoDrop)) && <div className="gsb-sep" />}
      {onShowDecks && (
        <button className="gsb-btn" onClick={onShowDecks} title="Card style — choose your card design">
          <span style={{ fontSize: size - 2, lineHeight: 1 }}>🃏</span>
        </button>
      )}
      {gameStarted && canAutoDrop && (
        <button
          className={`gsb-btn autodrop ${isAutoDropQueued ? 'queued' : ''}`}
          onClick={onToggleAutoDrop}
          title={isAutoDropQueued ? 'Auto Drop is queued — tap to cancel' : 'Queue Auto Drop when your turn arrives'}
          style={isAutoDropQueued ? {
            background: 'linear-gradient(135deg, #d32f2f, #f44336)',
            boxShadow: '0 0 12px rgba(244, 67, 54, 0.9)',
            border: '2px solid #fff',
            color: '#fff',
            animation: 'pulse 1.5s infinite'
          } : {
            background: 'rgba(244, 67, 54, 0.2)',
            border: '1px solid rgba(244, 67, 54, 0.5)',
            color: '#ff8a80'
          }}
        >
          <span style={{ fontSize: isMobile ? '9px' : '10px', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1' }}>
            <span>🛑</span>
            <span>{isAutoDropQueued ? 'CANCEL' : 'AUTO'}</span>
          </span>
        </button>
      )}
    </div>
  );
};

export default GameSideBar;
